const parseScheduleTime = (time: string): { hour: number; minute: number } | null => {
    const match = /^(\d{1,2}):(\d{2})$/.exec(time.trim());
    if (!match) {
        return null;
    }

    const hour = Number(match[1]);
    const minute = Number(match[2]);
    if (!Number.isInteger(hour) || !Number.isInteger(minute) || hour < 0 || hour > 23 || minute < 0 || minute > 59) {
        return null;
    }

    return { hour, minute };
};

export function formatScheduleTimeForDisplay(time: string, locales?: Intl.LocalesArgument): string {
    const parsed = parseScheduleTime(time);
    if (!parsed) {
        return time;
    }

    return new Intl.DateTimeFormat(locales, {
        hour: 'numeric',
        minute: '2-digit',
    }).format(new Date(2000, 0, 1, parsed.hour, parsed.minute));
}

export function formatScheduleTimeRangeForDisplay(startTime: string, endTime: string, locales?: Intl.LocalesArgument): string {
    return `${formatScheduleTimeForDisplay(startTime, locales)} - ${formatScheduleTimeForDisplay(endTime, locales)}`;
}
